import { render, staticRenderFns } from "./LandingReviews.vue?vue&type=template&id=b9ce78ec"
import script from "./LandingReviews.vue?vue&type=script&lang=js"
export * from "./LandingReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingReviewsCarousel: require('/src/components/landing/LandingReviewsCarousel.vue').default})
